import styles from './footer.module.css';

const Footer = () => {
  return (
    <div className={styles.footer_container}>
      <p>&copy;2024 | Ben-Hur Gican II | All rights reserved. </p>
    </div>
  );
};

export default Footer;
